import { device } from "shared/constants/device";
import styled from "styled-components";

export const FormChangePassword = styled.form`
  width:400px;
  border-radius:5px;
  padding: 12px;
  margin:0 auto;
  border:1px solid rgb(235, 235, 240);
  @media ${device.tablet} { 
    margin-top: 20px;
    width:100%;
   
  }
`
